import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";

const serviceRegions = [
  { id: 1, name: "London", coords: { lat: 51.5074, lng: -0.1278 }, coverage: "100%", teams: 12, projects: 320, responseTime: "2h" },
  { id: 2, name: "Manchester", coords: { lat: 53.4808, lng: -2.2426 }, coverage: "90%", teams: 8, projects: 210, responseTime: "3h" },
  { id: 3, name: "Birmingham", coords: { lat: 52.4862, lng: -1.8904 }, coverage: "85%", teams: 7, projects: 180, responseTime: "2.5h" },
  { id: 4, name: "Liverpool", coords: { lat: 53.4084, lng: -2.9916 }, coverage: "80%", teams: 6, projects: 160, responseTime: "3h" },
  { id: 5, name: "Leeds", coords: { lat: 53.8008, lng: -1.5491 }, coverage: "75%", teams: 6, projects: 140, responseTime: "3h" },
  { id: 6, name: "Newcastle", coords: { lat: 54.9784, lng: -1.6174 }, coverage: "70%", teams: 5, projects: 120, responseTime: "3.5h" },
  { id: 7, name: "Sheffield", coords: { lat: 53.3811, lng: -1.4701 }, coverage: "65%", teams: 5, projects: 110, responseTime: "3h" },
  { id: 8, name: "Nottingham", coords: { lat: 52.9548, lng: -1.1581 }, coverage: "60%", teams: 4, projects: 95, responseTime: "2.5h" },
  { id: 9, name: "Bristol", coords: { lat: 51.4545, lng: -2.5879 }, coverage: "55%", teams: 4, projects: 90, responseTime: "2h" },
  { id: 10, name: "Cardiff", coords: { lat: 51.4816, lng: -3.1791 }, coverage: "50%", teams: 3, projects: 85, responseTime: "2.5h" },
  { id: 11, name: "Belfast", coords: { lat: 54.5973, lng: -5.9301 }, coverage: "45%", teams: 3, projects: 70, responseTime: "4h" },
  { id: 12, name: "Edinburgh", coords: { lat: 55.9533, lng: -3.1883 }, coverage: "70%", teams: 5, projects: 120, responseTime: "3h" },
  { id: 13, name: "Glasgow", coords: { lat: 55.8642, lng: -4.2518 }, coverage: "75%", teams: 6, projects: 130, responseTime: "3h" },
  { id: 14, name: "Aberdeen", coords: { lat: 57.1497, lng: -2.0943 }, coverage: "40%", teams: 3, projects: 60, responseTime: "4h" },
  { id: 15, name: "Dundee", coords: { lat: 56.4620, lng: -2.9707 }, coverage: "35%", teams: 2, projects: 50, responseTime: "4h" },
  { id: 16, name: "Inverness", coords: { lat: 57.4778, lng: -4.2247 }, coverage: "30%", teams: 2, projects: 40, responseTime: "5h" },
  { id: 17, name: "Brighton", coords: { lat: 50.8225, lng: -0.1372 }, coverage: "60%", teams: 3, projects: 70, responseTime: "2h" },
  { id: 18, name: "Southampton", coords: { lat: 50.9097, lng: -1.4044 }, coverage: "55%", teams: 3, projects: 65, responseTime: "2h" },
  { id: 19, name: "Portsmouth", coords: { lat: 50.8198, lng: -1.0880 }, coverage: "50%", teams: 3, projects: 60, responseTime: "2h" },
  { id: 20, name: "Cambridge", coords: { lat: 52.2053, lng: 0.1218 }, coverage: "45%", teams: 2, projects: 55, responseTime: "2.5h" },
  { id: 21, name: "Oxford", coords: { lat: 51.7520, lng: -1.2577 }, coverage: "50%", teams: 2, projects: 60, responseTime: "2.5h" },
  { id: 22, name: "Leicester", coords: { lat: 52.6369, lng: -1.1398 }, coverage: "55%", teams: 3, projects: 65, responseTime: "2.5h" },
  { id: 23, name: "Coventry", coords: { lat: 52.4068, lng: -1.5197 }, coverage: "50%", teams: 2, projects: 55, responseTime: "2.5h" },
  { id: 24, name: "Hull", coords: { lat: 53.7676, lng: -0.3274 }, coverage: "40%", teams: 2, projects: 50, responseTime: "3h" },
  { id: 25, name: "Stoke-on-Trent", coords: { lat: 53.0027, lng: -2.1794 }, coverage: "45%", teams: 2, projects: 55, responseTime: "3h" },
  { id: 26, name: "York", coords: { lat: 53.9590, lng: -1.0815 }, coverage: "40%", teams: 2, projects: 50, responseTime: "3h" },
  { id: 27, name: "Milton Keynes", coords: { lat: 52.0406, lng: -0.7594 }, coverage: "50%", teams: 2, projects: 55, responseTime: "2.5h" },
  { id: 28, name: "Reading", coords: { lat: 51.4543, lng: -0.9781 }, coverage: "55%", teams: 3, projects: 65, responseTime: "2h" },
  { id: 29, name: "Exeter", coords: { lat: 50.7184, lng: -3.5339 }, coverage: "40%", teams: 2, projects: 45, responseTime: "3h" },
  { id: 30, name: "Plymouth", coords: { lat: 50.3755, lng: -4.1427 }, coverage: "35%", teams: 2, projects: 40, responseTime: "3h" }
];

export default function ServiceAreaMap() {
  return (
    <MapContainer
     center={[55, -3]}
     zoom={6}
     className="w-full h-[500px] rounded-lg shadow"
      // style={{ height: "500px", width: "100%" }}
    >
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution="&copy; OpenStreetMap contributors"
      />

      {serviceRegions.map((region) => (
        <Marker key={region.id} position={region.coords}>
          <Popup>
            <h3>{region.name}</h3>
            <p><strong>Coverage:</strong> {region.coverage}</p>
            <p><strong>Teams:</strong> {region.teams}</p>
            <p><strong>Projects:</strong> {region.projects}</p>
            <p><strong>Response Time:</strong> {region.responseTime}</p>
          </Popup>
        </Marker>
      ))}
    </MapContainer>
  );
}
